import { MessageSquareOff } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useToast } from '@/hooks/use-toast';
import { useCustomerSmsOptOut, useSetCustomerSmsOptOut } from '@/hooks/useSmsSettings';

/**
 * Owner control on a customer: "Don't text this customer". Hidden until the
 * opt-out flag can be read (no customer record, or an older database).
 * A customer who replies STOP to a text is switched on automatically.
 */
export function CustomerSmsOptOut({ customerId, disabled }: { customerId: string | null | undefined; disabled?: boolean }) {
  const { toast } = useToast();
  const { data: optedOut } = useCustomerSmsOptOut(customerId);
  const setOptOut = useSetCustomerSmsOptOut(customerId);
  if (!customerId || optedOut == null) return null;

  return (
    <div className="mt-4 flex items-center justify-between gap-3 border-t border-border pt-4" data-testid="customer-sms-opt-out">
      <label htmlFor="customer-sms-opt-out" className="flex items-start gap-2 text-[12.5px] text-muted-foreground">
        <MessageSquareOff className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        Don’t send this customer text messages
      </label>
      <Switch
        id="customer-sms-opt-out"
        checked={optedOut}
        disabled={disabled || setOptOut.isPending}
        onCheckedChange={(value) =>
          setOptOut.mutate(value, {
            onError: () => toast({ title: 'Couldn’t save that', variant: 'destructive' }),
          })
        }
      />
    </div>
  );
}
